export const AUTH_NAME = "auth_name";
export const AUTH_ROLE = "auth_role";
export const AUTH_ROLE_ID = "auth_roleId";
export const AUTH_USER_ID = "auth_userId";
export const AUTH_TEACHER_ID = "auth_teacherId";
export const AUTH_STUDENT_ID = "auth_studentId";
export const AUTH_CURRENT_SESSION = "auth_current_sessionId";
export const AUTH_CURRENT_DATA = "auth_current_data";
export const AUTH_CHILDREN_DATA = "auth_children_data"


export const AUTH_TOKEN = "auth_token";
export const AUTH_PARENT_ID = "auth_parent_id";
export const AUTH_STUDENTS = "auth_students";
export const AUTH_PARENT_NAME = "auth_parent_name";
export const AUTH_TOTAL_CHILDREN = "auth_total_children";
export const AUTH_CHILD_ID = "auth_child_id";
export const AUTH_CHILD_NAME =  "auth_child_name";
export const AUTH_EMAIL_ADDRESS = "auth_email_address";
export const AUTH_DOB = "auth_dob";
export const AUTH_MOBILE_NUMBER = "auth_mobile_number";
export const AUTH_DRIVER_ID = "auth_driver_id";
export const AUTH_BUS_ID = "auth_bus_id";
export const AUTH_DRIVER_NAME = "auth_driver_name";
export const AUTH_EMAIL = "auth_email";
